import { render, staticRenderFns } from "./SetWarehouse.vue?vue&type=template&id=6fa7f87e&scoped=true&"
import script from "./SetWarehouse.vue?vue&type=script&lang=js&"
export * from "./SetWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa7f87e",
  null
  
)

export default component.exports